/* import {
  br_sir,
  cryptography,
  cyber_security_trends,
  digital_trust,
  django_react,
  ka_sir,
  kc_maam,
  network_security,
  sd_react,
  software_dev,
  software_trends_india,
  unix,
  web_security,
} from "assets"; */

import br_sir from "../assets/images/courses/BR.png";
import kc_maam from "../assets/images/courses/KC.jpeg";
import ka_sir from "../assets/images/courses/KA.png";
import cryptography from "../assets/images/courses/real_world_cryptography.png";
import cyber_security_trends from "../assets/images/courses/cybersecurity.webp";
import digital_trust from "../assets/images/courses/digital_trust.png";
import django_react from "../assets/images/courses/django-react.webp";
import network_security from "../assets/images/courses/network_security.webp";
import sd_react from "../assets/images/courses/software_dev_react.jpg";
import software_dev from "../assets/images/courses/software_dev.jpg";
import software_trends_india from "../assets/images/courses/software_trends_india.png";
import unix from "../assets/images/courses/unix.png";
import web_security from "../assets/images/courses/web_security.webp";

import kaustubh_saraf_review from "../assets/testimonials/kaustubh_saraf_web_sec_review.mp4";
import satyankar_chandra_review from "../assets/testimonials/satyankar_chandra_testimonial.mp4";

import arnab_bhakta from "../assets/testimonials/arnab_bhakta.mp4";

import friday_web_security from "../assets/testimonials/friday_web_security.mp4";

import monday_web_security_student from "../assets/testimonials/monday_web_security_student.mp4";

import raj_pastagiya from "../assets/testimonials/raj_pastagiya.mp4";

import web_security_student from "../assets/testimonials/web_security_student.mp4";

// import youtube_size from "../assets/testimonials/youtube_size.mp4";
import crypto_certificate from "../assets/images/courses/crypto_certificate.png"
import software_certificate from "../assets/images/courses/software_certificate.png"
import cyber_certificate from "../assets/images/courses/cyber_certificate.png"
import unix_certificate from "../assets/images/courses/unix_certificate.png"
import cybersecurity_programme_brochure from "../assets/brochures/cybersecurity_programme_brochure.pdf"
import real_world_cryptography_brochure from "../assets/brochures/real_world_cryptography_brochure.pdf"
import swd_programme_brochure from "../assets/brochures/swd_programme_brochure.pdf"
import unix_frontend_brochure from "../assets/brochures/unix_frontend_brochure.pdf"
import raj_pastagiya_thumbnail from "../assets/testimonials/raj_pastagiya.png";
import arnab_bhakta_thumbnail from "../assets/testimonials/arnab_bhakta.png";

import ignas_silickas_thumbnail from "../assets/testimonials/ignas_silickas.png";
import satyankar_chandra_thumbnail from "../assets/testimonials/satyankar_chandra.png";
import shruti_patil_thumbnail from "../assets/testimonials/shruti_patil.png";
import theotime_flichy_thumbnail from "../assets/testimonials/theotime_flichy.png";
import kaustubh_saraf_thumbnail from "../assets/testimonials/kaustubh_saraf.png";

export const course_instructors = {
  KC: {
    image: kc_maam,
    name: "Prof. Kameswari Chebrolu",
    description: `Prof. Kameswari Chebrolu is a faculty member in the Department
              of Computer Science and Engineering at IIT Bombay. She received her M.S. and Ph.D. in Electrical and Computer Engineering from University of California, San Diego. Her interests
              are in developing cutting-edge technology for real-world use and
              high social impact. She has conducted numerous teacher-training
              workshops, impacting over 10,000 educators in specialized
              Computer Science subjects and the utilization of educational
              technology tools. Currently, she holds the prestigious Prof.
              D.M. Dhamdhere Chair for Excellence in Teaching Methods. Prof.
              Chebrolu's commitment to excellence has been recognized through
              awards such as the IITB Excellence in Teaching Award in 2010 and 2022.`
  },
  BR: {
    image: br_sir,
    name: "Prof. Bhaskaran Raman",
    description: `Prof. Bhaskaran Raman received his B. Tech in Computer Science and Engineering 
              from Indian Institute of Technology, Madras in May 1997. He received his M.S. and Ph.D. in Computer 
              Science from University of California, Berkeley, in 1999 and 2002 respectively. He was a faculty 
              in the CSE department at Indian Institute of Technology, Kanpur (India) from June 2003. Since July 2007, 
              he is a faculty at the CSE department at Indian Institute of Technology, Bombay (India). His research 
              interests and expertise are in communication networks, wireless/mobile networks, and technology for education.`
  },
  KA: {
    image: ka_sir,
    name: "Prof. Kumar Appaiah",
    description: `Prof. Kumar Appaiah is a faculty member in the Department of Electrical Engineering at IIT Bombay. He received his Ph.D in Electrical and Computer Engineering from University of Texas at Austin. His research interests are in
              optical communications and wireless communications. He is also keenly
              interested in the promotion of Free/Libre and Open Source Software in
              the field of education. He has conducted several courses on Linux and
              Python for industries and is a member of the Debian project that
              is responsible for the volunteer driven Debian GNU/Linux operating system.`
  }
}

export const brochureMapping = {
  // Program brochures
  1: swd_programme_brochure, // Professional Certification in Software Development
  6: cybersecurity_programme_brochure, // Professional Certification in Cybersecurity

  // Course brochures
  2: unix_frontend_brochure, // Introduction to Unix and Frontend Fundamentals
  7: real_world_cryptography_brochure, // Real World Cryptography

  // Add more mappings as needed
  // 3: mern_brochure, // Full-Stack MERN Development (when available)
  // 4: django_react_brochure, // Django and React (when available)
  // 5: web_security_brochure, // Web Security (when available)
  // 8: network_security_brochure, // Network Security (when available)
};

export const courses = [
  {
    id: 1,
    program_title: "Professional Certification in Software Development",
    active: true,
    category: "Professional Certificate",
    program_start_date: "N/A",
    duration: "1 year",
    program_type: "Online",
    credits: "",
    level: "",
    certificate: `${software_certificate}`,
    image: `${software_dev}`,
    subCourses: [
      {
        id: 101,
        courseId: 2,
        title: "Introduction to Unix and Frontend Fundamentals",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Ongoing",
        startDate: "Sept 01, 2025",
        jobRoles: ["Junior Web Developer", "Web Content Developer"],
      },
      {
        id: 102,
        courseId: 3,
        title: "Full-Stack MERN Development with Apache/Nginx Configuration",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Upcoming",
        startDate: "Jan 02, 2026",
        jobRoles: [
          "Full-Stack Developer",
          "Back-End Developer",
          "Web Developer",
          "DevOps Engineer",
          "Application Support Engineer",
        ],
      },
      {
        id: 103,
        courseId: 4,
        title: "Cloud Ready Full-Stack Web Development with Django and React",
        duration: "14 weeks",
        credits: 8,
        category: "Individual Course - Upcoming",
        startDate: "May 04, 2026",
        jobRoles: [
          "Full-Stack Developer",
          "Cloud Application Developer",
          "DevOps Engineer",
          "Front-End Developer",
          "Back-End Developer",
        ],
      },
      {
        id: 104,
        courseId: 5,
        title: "Web Security",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Upcoming",
        startDate: "May 04, 2026",
        jobRoles: [
          "Security Consultant",
          "Security Architect",
          "Application Security Engineer/Analyst",
          "Penetration Tester",
          "DevSecOps Engineer",
          "Software Security Engineer",
          "Vulnerability Management Specialist",
        ],
      },
    ],
    description: `<p>Despite soaring demand for software developers, companies continue to face a persistent shortage of qualified people. To bridge this divide, the Trust Lab at IIT Bombay is launching a flexible, affordable, and highly practical professional certification program in software development. Unlike traditional programs that emphasize theory, this initiative places real-world skills at the heart of the learning experience.</p>
    <p>The program offers a comprehensive, industry-aligned curriculum that equips learners with essential tools and technologies for modern web and software development. Participants will build a strong foundation through weekly (not end-of-term) hands-on lab exercises designed to reinforce key concepts. The program  begins with exposure to unix and web development fundamentals—covering HTML, CSS, and JavaScript for creating static web pages—before progressing to dynamic applications using PHP, the full-stack MERN framework, and Django with React. Learners will also gain exposure to testing practices and CI/CD pipelines for cloud deployment. Future expansions of the program will include courses in cloud computing, software engineering, and system programming.</p>
    <p>Join us in fostering innovation and equipping yourself for success in the fast-evolving field of Information Technology. The program is open to both working professionals and college/university students across India.</p>`,
    trends_img: `${software_trends_india}`,
    market_trends_title: "India's Software Services Market Surge: A Booming Industry with Vast Opportunities",
    trends: [
      {
        description:
          "The India Software Services Export Market size is estimated at USD 151.60 billion in 2024, and is expected to reach USD 189.19 billion by 2029.",

        source_title: "mordorintelligence",
        source:
          "https://www.mordorintelligence.com/industry-reports/india-software-services-export-industry-market",
      },
      {
        description:
          "An estimated 9-10 lakh additional jobs for skilled software engineers will be created in the next 18 months.",
        source_title: "Economic Times",
        source:
          "https://economictimes.indiatimes.com/jobs/hr-policies-trends/digital-india-sparks-rush-for-new-age-software-engineers/articleshow/110126612.cms?from=mdr",
      },
      {
        description:
          "Software development roles in India offer competitive salaries, with annual average base pay ranging from 3L-18L, making it a lucrative career path.",
        source_title: "intellipaat",
        source: "https://intellipaat.com/blog/full-stack-developer-salary/",
      },
    ],
    reviews: [],
  },
  {
    id: 6,
    program_title: "Professional Certification in Cybersecurity",
    active: true,
    category: "Professional Certificate",
    program_start_date: "N/A",
    duration: "1 year",
    program_type: "Online",
    credits: "",
    certificate: `${cyber_certificate}`,
    level: "",
    image: `${digital_trust}`,
    description: `<p>India’s cybersecurity market is projected to grow significantly, reaching USD 7.23 billion by 2029 and the sector is expected to create over one million job opportunities in India. Despite this booming demand, India faces a critical shortage of qualified cybersecurity professionals. To address this critical skills gap, Trust Lab at IIT Bombay is launching a flexible, affordable, and hands-on professional certification program in cybersecurity.  Unlike traditional programs that emphasize theory, this initiative places real-world skills at the heart of the learning experience. Participants will not only gain foundational skills, but each concept will be reinforced with weekly hands-on lab exercises. They will learn to identify vulnerabilities, implement strong security measures, and respond effectively to emerging threats across various domains.</p>
    <p>Join us in building a more secure trustworthy digital ! The program is open to both working professionals and college/university students across India, empowering a new generation of cybersecurity talent.</p>
`,
    trends_img: `${cyber_security_trends}`,
    market_trends_title: "India's Cybersecurity Market Surge: A Booming Industry with Vast Opportunities",
    trends: [
      {
        description:
          "India's Software Services Market valued at USD 3.05 Billion in 2023 and is anticipated to reach USD 7.23 Billion in 2029.",
        source_title: "Globenewswire",
        source:
          "https://www.globenewswire.com/news-release/2024/01/16/2810072/0/en/India-Cybersecurity-Market-Report-2023-Analysis-Competition-Forecasts-Opportunities-2019-2029F.html",
      },
      {
        description:
          "Cyber security to create one million job opportunities in India by 2025.",
        source_title: "SKILLOGIC",
        source:
          "https://skillogic.com/blog/cyber-security-scope-in-india/",
      },
      {
        description:
          "Cybersecurity roles in India offer competitive salaries compared to other IT jobs; annual average base payout is between ₹5L – ₹21L.",
        source_title: "analytixlabs",
        source:
          "https://www.analytixlabs.co.in/blog/cyber-security-salary-in-india/",
      },
    ],
    subCourses: [
      {
        id: 201,
        courseId: 7,
        title: "Real World Cryptography",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Ongoing",
        startDate: "Sept 01, 2025",
        jobRoles: [
          "Security Architect",
          "Information Security Analyst",
          "Network Security Engineer",
          "Data Protection Officer",
          "Security Consultant",
          "Research Scientist",
        ],
      },

      {
        id: 202,
        courseId: 8,
        title: "Network Security",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Upcoming",
        startDate: "Jan 02, 2026",
        jobRoles: [
          "Network Security Engineer/Analyst",
          "Security Architect",
          "Network Administrator",
          "Security Consultant",
          "Incident Response Specialist",
          "Security Operations Center (SOC) Analyst",
        ],
      },
      {
        id: 104,
        courseId: 5,
        title: "Web Security",
        duration: "14 weeks",
        credits: 6,
        category: "Individual Course - Upcoming",
        startDate: "May 04, 2026",
        jobRoles: [
          "Security Consultant",
          "Security Architect",
          "Application Security Engineer/Analyst",
          "Penetration Tester",
          "DevSecOps Engineer",
          "Software Security Engineer",
          "Vulnerability Management Specialist",
        ],
      },
      // {
      //   id: 204,
      //   title: "Enterprise and Cloud Security",
      //   duration: "14 weeks",
      //   credits: 6,
      //   startDate: null,
      //   jobRoles: [
      //     "Cloud Security Architect/Engineer",
      //     "Chief Information Security Officer (CISO)",
      //     "Enterprise Security Analyst",
      //     "Security Operations Center (SOC) Analyst",
      //   ],
      // },
    ],
    reviews: [
      {
        name: "Thèotime Flichy",
        college: "University of Montreal, Canada",
        video_src: `${web_security_student}`,
        poster: theotime_flichy_thumbnail,
        description: "CLab was fun and easy to use—small steps built up to complex tasks.",
      },
      {
        name: "Ignas Silickas",
        college: "KTH Royal Insitute of Technology, Sweden",
        video_src: `${friday_web_security}`,
        poster: ignas_silickas_thumbnail,
        description: "The hands-on labs and TA support made this one of the most enjoyable courses.",
      },
      {
        name: "Shruti Patil",
        college: "National Insitute of Technology, Goa",
        video_src: `${monday_web_security_student}`,
        poster: shruti_patil_thumbnail,
        description: "I loved how theory was followed by hands-on labs—my favorite part.",
      },
      {
        name: "Raj Pastagiya",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${raj_pastagiya}`,
        poster: raj_pastagiya_thumbnail,
        description: "Well-structured, with hands-on labs that made complex topics easy to understand.",
      },
      {
        name: "Kaustubh Saraf",
        college: "G.H. Raisoni COE, Nagpur",
        video_src: `${kaustubh_saraf_review}`,
        poster: kaustubh_saraf_thumbnail,
        description:
          "After solving the labs I was able to interpret the knowledge with real world scenarios.",
      },
      {
        name: "Satyankar Chandra",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${satyankar_chandra_review}`,
        poster: satyankar_chandra_thumbnail,
        description:
          "I found platform really convenient and simplistic to use. ",
      },
      {
        name: "Arnab Bhakta",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${arnab_bhakta}`,
        poster: arnab_bhakta_thumbnail,
        description: "Now I write cleaner, more secure code—this course changed my whole approach.",
      },
    ],
  },
  {
    id: 2,
    parent_program_ids: [1],
    program_title: "Introduction to Unix and Frontend Fundamentals",
    active: true,
    category: "Individual Course - Ongoing",
    program_start_date: "Sep 01, 2025",
    duration: "12 - 14 weeks",
    certificate: `${unix_certificate}`,
    program_type: "Online",
    credits: "",
    level: "",
    total_time_commitment: "8 - 10 hrs per week (Interaction will be conducted during evenings/weekends)",
    pre_recorded_content: "1 - 2 hrs per week",
    weekly_lab: "2 - 3 hrs per week (TA assisted)",
    image: `${unix}`,
    description:
      "In today’s job market, web development and version control are highly sought-after skills across IT industries. This lab-intensive foundational web development course begins with the fundamentals of Unix, which are essential for managing web servers both locally and in the cloud (and also essential for interfacing with our lab platform across all courses). Participants will then dive into HTML, CSS, and JavaScript—the core building blocks of web development—to structure, style, and add interactivity to web pages. The course also covers Git, equipping participants with the skills to effectively manage and collaborate on code. By the end of the course, participants will be well-prepared to confidently create and maintain static web applications.",
    course_details: {
      prerequisites: `<div><ul><li>Programming experience (C/C++/Python/Java/Bash) (For Unix only)</li></ul></div>`,
      duration: `<div><p class="size18 weight-700 mb-0">Fees: Different categories have different fees (inclusive of taxes) for this course:</p><ul><li>Student: Rs 24,000</li><li>Teacher: Rs 27,500</li><li>Others: Rs 30,000</li></ul></div>`,
    },
    instructors: [course_instructors.BR, course_instructors.KC],
    course_content: {
      modules: [
        {
          module_name: "Module 1: Unix Command Line",
          module_description: `
                <p>Covers various commands web developers need to set up and maintain web servers (Linux/cloud).</p>
                <p>Topics include:</p>
                <ul>
                    <li>File and Directory Commands</li>
                    <li>File Viewing and Editing Commands</li>
                    <li>Commands for File Analysis</li>
                    <li>Process Management Commands</li>
                    <li>Networking Commands</li>
                    <li>Security and Permissions</li>
                    <li>Package Management</li>
                    <li>System and Server Management Commands</li>
                </ul>
                <p>Practical sessions will explore all these commands hands-on.</p>
            `,
        },
        {
          module_name: "Module 2: Overview of Web, IDE",
          module_description: `
                <p>VSCode editor overview for web coding (installation, popular features, extensions);</p>
                <p>Web overview (web page, HTTP, HTTPS, session management - cookies/tokens, server internals - static/dynamic content).</p>
            `,
        },
        {
          module_name: "Module 3: HTML",
          module_description: `
                <p>Building Blocks:</p>
                <ul>
                    <li>Elements and Attributes</li>
                    <li>Text</li>
                    <li>Lists</li>
                    <li>Links</li>
                    <li>Images</li>
                    <li>Tables</li>
                    <li>Forms</li>
                    <li>Extra Markup</li>
                    <li>Multimedia</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 4: CSS",
          module_description: `
                <p>Topics include:</p>
                <ul>
                    <li>Linking CSS in HTML</li>
                    <li>Selectors and Declarations (building blocks)</li>
                    <li>Color</li>
                    <li>Styling Text/Links</li>
                    <li>Layout: Box Model, Positioning, Display, Flexbox, CSS Grid, HTML5 layout</li>
                    <li>Styling Lists</li>
                    <li>Styling Tables</li>
                    <li>Styling Forms</li>
                    <li>Styling Cursor</li>
                    <li>Styling Images</li>
                    <li>Best Practices for Designing Web Pages</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 5: JavaScript",
          module_description: `
                <p>Topics include:</p>
                <ul>
                    <li>Linking JavaScript in HTML</li>
                    <li>Basic Building Blocks: Variables, Data Types, and Operators</li>
                    <li>Control Structures: Conditionals (if, else), Loops (for, while)</li>
                    <li>Functions</li>
                    <li>Arrays and Objects</li>
                    <li>Classes and Modules</li>
                    <li>Pattern Matching</li>
                    <li>DOM Manipulation</li>
                    <li>Handling Events</li>
                    <li>jQuery Library</li>
                    <li>Asynchronous JavaScript</li>
                    <li>HTML5 APIs</li>
                    <li>Best Practices for Coding in JavaScript</li>
                    <li>Debugging Techniques</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 6: Version Control",
          module_description: `
                <p>Introduction to Git:</p>
                <ul>
                    <li>Setting up Git</li>
                    <li>Basic Git Workflow</li>
                    <li>Branching and Merging</li>
                    <li>Tracking and Inspecting Changes</li>
                    <li>Remote Repositories</li>
                    <li>GitHub/Lab Integration</li>
                </ul>
            `,
        },
      ],
    },
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 24,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 19,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs 72,000 </p></div>`,
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
  },
  {
    id: 3,
    parent_program_ids: [1],
    active: false,
    program_title:
      "Full-Stack MERN Development with Apache/Nginx Configuration",
    category: "Individual Course - Upcoming",
    program_start_date: "Jan 2, 2026",
    duration: "14 weeks",
    program_type: "Online",
    credits: "",
    level: "",
    image: `${sd_react}`,
    description:
      "In the ever-evolving field of IT, mastering dynamic web development is essential for creating interactive and engaging online experiences. This lab-intensive course starts with a basic introduction to dynamic web development using PHP, a simple and accessible language that allows beginners to quickly grasp server-side logic and database interactions. Participants will then build upon this knowledge by exploring the MERN stack—MongoDB, Express.js, React, and Node.js—a modern framework for developing complex and responsive web applications. Finally, the course will guide participants through the process of hosting these applications on web servers like Apache and Nginx. By the end of the course, participants will be well-prepared to develop and deploy dynamic web applications.",
    course_details: {
      prerequisites: `<div><p class="size18 weight-700 mb-0">Pre-requisites:</p><ul><li>Knowledge of Unix Command Line, Web Architecture, HTML, CSS, Javascript, and SQL</li></ul></div>`,
      duration: `<div><p class="size18 weight-700 mb-0">Fees: Different categories have different fees (inclusive of taxes) for this course:</p><ul><li>Student: Rs 28,800</li><li>Teacher: Rs 32,400</li><li>Others: Rs 36,000</li></ul></div>`,
    },
    course_content: {
      modules: [
        {
          module_name: "Module 1: PHP and Apache Web Server Configuration",
          module_description: `
                <p>This module covers:</p>
                <ul>
                    <li>PHP Installation</li>
                    <li>Basic Syntax and Control Structures</li>
                    <li>Object Oriented Programming: classes, objects, methods, interfaces, inheritance</li>
                    <li>Error Handling and Debugging</li>
                    <li>Introduction to SQL (for database integration)</li>
                    <li>Introduction to Composer</li>
                    <li>CodeIgniter (MVC architecture)</li>
                    <li>Creating Static, Dynamic, and CRUD Applications with CodeIgniter including Authentication</li>
                </ul>
                <p>A PHP application will be hosted on an Apache web server, covering:</p>
                <ul>
                    <li>Installation</li>
                    <li>httpd.conf Configuration</li>
                    <li>Virtual Host Setup</li>
                    <li>Modules and Extensions (URL Rewriting/Redirection, HTTPS Setup)</li>
                    <li>Log Management</li>
                    <li>Security Best Practices (.htaccess)</li>
                </ul>
                <p>Practical sessions will explore all these topics using hands-on exercises.</p>
            `,
        },
        {
          module_name:
            "Module 2: MERN Stack (MongoDB, Express, React, Node.js) and Nginx Web Server Configuration",
          module_description: `
                <p>This module covers:</p>
                <ul>
                    <li><strong>MongoDB:</strong>
                        <ul>
                            <li>Documents, Collections, Schema-less structure</li>
                            <li>CRUD Operations, Mongo Shell and Shell Scripting</li>
                            <li>Aggregation Framework, MongoDB Atlas, and Mongoose (ODM)</li>
                        </ul>
                    </li>
                    <li><strong>Node.js:</strong>
                        <ul>
                            <li>Overview, Non-blocking I/O, Use Cases</li>
                            <li>Modules and NPM, File System and Streams</li>
                            <li>Asynchronous Programming (callbacks, promises, async/await, error handling)</li>
                        </ul>
                    </li>
                    <li><strong>Express.js:</strong>
                        <ul>
                            <li>Setting up Express, Routing, Handler Function, Middleware</li>
                            <li>RESTful API Development (CRUD APIs)</li>
                            <li>Error Handling, Authentication/Authorization using JWT and OAuth</li>
                            <li>Testing with Postman API</li>
                        </ul>
                    </li>
                    <li><strong>React (Basic Introduction):</strong>
                        <ul>
                            <li>JavaScript XML (JSX)</li>
                            <li>Components and Their Lifecycle, State, Props, Hooks, Routing</li>
                            <li>Connecting with APIs</li>
                        </ul>
                    </li>
                </ul>
                <p>A MERN application will be hosted on an Nginx web server, covering:</p>
                <ul>
                    <li>Installation</li>
                    <li>Core Directives, Server Blocks</li>
                    <li>Modules, Handling Dynamic Content (Reverse Proxy)</li>
                    <li>Load Balancing, Log Management</li>
                    <li>Security</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
      ],
    },
    instructors: [course_instructors.BR, course_instructors.KA, course_instructors.KC],
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 30,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 24,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs 90,000</p></div>`,
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
  },
  {
    id: 4,
    parent_program_ids: [1],
    program_title:
      "Cloud Ready Full-Stack Web Development with Django and React",
    active: false,
    category: "Individual Course - Upcoming",
    program_start_date: "May 04, 2026",
    duration: "14 weeks",
    program_type: "Online",
    credits: "8 credits",
    level: "",
    image: `${django_react}`,
    description:
      "In today's tech-driven landscape, proficiency in cloud-ready web development is essential for building modern web applications. This lab-intensive course introduces participants to robust back-end development with Django and dynamic front-end development using React. It also covers testing frameworks like Selenium and Cypress for effective application validation. Learners will explore Continuous Integration and Continuous Deployment (CI/CD) practices, along with Docker for containerization and automated deployment on the cloud. By the end of the course, participants will confidently develop, test, and deploy web applications in a cloud environment.",
    course_details: {
      prerequisites: `<div><p class="size18 weight-700 mb-0">Pre-requisites:</p><ul><li>Knowledge of Python</li><li>Knowledge of Unix Command Line, Web Architecture, HTML, CSS, and Javascript</li><li>Knowledge of web servers, web frameworks like MERN stack, and GIT</li></ul></div>`,
      duration: `<div><p class="size18 weight-700 mb-0">Fees: Different categories have different fees (inclusive of taxes) for this course:</p><ul><li>Student: Rs 38,400</li><li>Teacher: Rs 43,200</li><li>Others: Rs 48,000</li></ul></div>`,
    },
    instructors: [course_instructors.BR, course_instructors.KA, course_instructors.KC],
    course_content: {
      modules: [
        {
          module_name: "Module 1: Python Background",
          module_description: `
                <p>This module provides a quick overview of Python as a precursor to Django, covering:</p>
                <ul>
                    <li>Python Installation & Setup</li>
                    <li>Basic Syntax & Data Types</li>
                    <li>Control Structures</li>
                    <li>Functions</li>
                    <li>Data Structures: lists, tuples, sets, dictionaries and their operations</li>
                    <li>Object-Oriented Programming (OOP)</li>
                    <li>Modules & Packages (including pip)</li>
                    <li>File Handling</li>
                    <li>Error Handling (try, except, finally)</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 2: Django",
          module_description: `
                <p>This module covers:</p>
                <ul>
                    <li>Brief Introduction to Django</li>
                    <li>Django Installation & Setup</li>
                    <li>Django Applications</li>
                    <li>Admin Interface</li>
                    <li>Views & URL Routing</li>
                    <li>Templates</li>
                    <li>Database Models</li>
                    <li>Authentication & Authorization</li>
                    <li>RESTful APIs (for React Integration)</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 3: React (Advanced Concepts)",
          module_description: `
                <p>This module covers advanced concepts in React, including:</p>
                <ul>
                    <li>JSX & Component Patterns</li>
                    <li>Styling Patterns</li>
                    <li>State Management with Redux</li>
                    <li>React Hooks</li>
                    <li>React Router</li>
                    <li>Handling Forms & Validation</li>
                    <li>Performance Optimization</li>
                    <li>Error Boundaries & Handling Errors</li>
                    <li>Connecting with APIs (Django Backend Integration)</li>
                    <li>React with WebSockets (Real-Time Communication)</li>
                    <li>Deployment</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 4: Testing",
          module_description: `
                <p>This module covers testing frameworks:</p>
                <ul>
                    <li><strong>Selenium</strong> (end-to-end testing, cross-browser testing):
                        <ul>
                            <li>WebDriver Concept</li>
                            <li>Installation and Setup</li>
                            <li>Launching Browsers and Navigating to URLs</li>
                            <li>Locating Elements</li>
                            <li>Interacting with Web Elements</li>
                            <li>Basic Waits</li>
                        </ul>
                    </li>
                    <li><strong>Cypress</strong> (front-end testing of React):
                        <ul>
                            <li>Environment Setup</li>
                            <li>Writing and Running Tests</li>
                            <li>Locating Elements</li>
                            <li>Interacting with Web Elements</li>
                            <li>Assertions</li>
                            <li>Automatic Waiting</li>
                            <li>Basic Navigation & Page Interactions</li>
                        </ul>
                    </li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
        {
          module_name: "Module 5: CI/CD Pipelines and Cloud Deployment",
          module_description: `
                <p>This module provides an overview of CI/CD concepts, covering:</p>
                <ul>
                    <li>GitLab Repositories and Workflows</li>
                    <li>Introduction to Build and Test Automation (running unit tests, linting for Django/React on commits/pulls)</li>
                    <li>Brief Introduction to Cloud Services</li>
                    <li>Introduction to Docker</li>
                    <li>Building Images for Django and React Apps</li>
                    <li>Docker Compose for Multi-Container Setups (frontend, backend, database)</li>
                    <li>Setting Up Deployment Pipelines for Automated Cloud Deployment</li>
                </ul>
                <p>Practical sessions will explore all these topics hands-on.</p>
            `,
        },
      ],
    },
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 36,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 29,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs. 1,08,000</p></div>`,
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
  },
  {
    id: 7,
    parent_program_ids: [6],
    program_title: "Real World Cryptography",
    active: true,
    category: "Individual Course - Ongoing",
    program_start_date: "Sep 01, 2025",
    duration: "12 - 14 weeks",
    program_type: "Online",
    credits: "",
    level: "",
    certificate: `${crypto_certificate}`,
    image: `${cryptography}`,
    description:
      "Learning cryptography is like understanding the principles of physics before designing a bridge. While one might manage to build a bridge without knowing physics, how strong will it be? Similarly, without understanding cryptography, one can't effectively create or comprehend secure systems. This practical course with weekly hands-on labs will offer a deep dive into core cryptographic techniques, from encryption and hashing to digital signatures and secure key exchange. Through realistic scenarios and real-world applications/standards, participants will gain a solid grasp of how these techniques safeguard information across networks, applications, and systems.",
    course_details: {
      prerequisites: `<div><ul class="size18"><li>Knowledge of Unix Command Line</li><li>Programming knowledge in C++ or Python</li></ul></div>`,
      duration: `<div><p class="size18 weight-700 mb-0">Fees: Different categories have different fees (inclusive of taxes) for this course: </p><ul class="size18"><li>Student: Rs 28,800</li><li>Teacher: Rs 32,400</li><li>Others: Rs 36,000</li></ul></div>`,
    },
    course_content: {
      modules: [
        {
          module_name: "Introduction",
          module_description: `
                <p>Motivation, History, Modern Cryptography</p>
            `,
        },
        {
          module_name: "Confidentiality",
          module_description: `
                <p>Confidentiality Overview; Crypto-analysis; One Time pads;</p>
                <p>Symmetric-key encryption:</p>
                <ul>
                    <li>DES</li>
                    <li>3-DES</li>
                    <li>AES</li>
                </ul>
                <p>Block Modes and corresponding attacks:</p>
                <ul>
                    <li>ECB</li>
                    <li>CBC</li>
                    <li>CTR</li>
                    <li>CFB</li>
                    <li>OFB</li>
                    <li>XTR</li>
                </ul>
                <p>Format Preserving Encryption (FPE);</p>
                <p>Asymmetric key encryption:</p>
                <ul>
                    <li>RSA</li>
                    <li>ECC</li>
                </ul>
                <p>Attacks and Defense.</p>
            `,
        },
        {
          module_name: "Integrity/Data Authentication",
          module_description: `
                <p>Hash Properties; Hash construction:</p>
                <ul>
                    <li>SHA-1</li>
                    <li>SHA-3</li>
                </ul>
                <p>Message Authentication Codes (MAC) and corresponding attacks and defense:</p>
                <ul>
                    <li>CMAC</li>
                    <li>HMAC</li>
                </ul>
                <p>Digital Signatures and corresponding attacks and defense:</p>
                <ul>
                    <li>RSA</li>
                    <li>ECDSA</li>
                </ul>
                <p>Random Number Generators:</p>
                <ul>
                    <li>Blum Blum Shub</li>
                    <li>CSPRNG</li>
                    <li>CTR-DRBG</li>
                    <li>Micali–Schnorr PRNG</li>
                </ul>
                <p>True random number generators (TRNGs); Intel's DRNG chip internals.</p>
            `,
        },
        {
          module_name: "Cryptographic Protocols",
          module_description: `
                <p>Long term Symmetric Key distribution:</p>
                <ul>
                    <li>Diffie-Hellman key exchange</li>
                    <li>ECDH</li>
                    <li>Key Distribution Center (KDC)</li>
                </ul>
                <p>Asymmetric key distribution:</p>
                <ul>
                    <li>Certificate Authorities (CA)</li>
                    <li>Public Key Infrastructure (PKI)</li>
                </ul>
                <p>Human Authentication:</p>
                <ul>
                    <li>Passwords</li>
                    <li>Password quality</li>
                    <li>Password storage</li>
                </ul>
                <p>Cryptographic Authentication:</p>
                <ul>
                    <li>Challenge-response</li>
                    <li>One-way, two-way, mediated authentication</li>
                    <li>Kerberos</li>
                </ul>
                <p>Case Study of TLS Protocol.</p>
            `,
        },
        {
          module_name: "Latest Trends in Cryptography",
          module_description: `
                <p>High-level overview of:</p>
                <ul>
                    <li>Cryptocurrency</li>
                    <li>Zero-knowledge proofs</li>
                    <li>Secure multiparty computation</li>
                </ul>
            `,
        },
        {
          module_name: "Labs",
          module_description: `
                <ul>
                    <li>Frequency Analysis, Vigenère Cipher</li>
                    <li>OpenSSL for symmetric key encryption</li>
                    <li>OpenSSL for RSA and ECC encryption</li>
                    <li>OpenSSL for hashes, MAC</li>
                    <li>OpenSSL for digital signatures</li>
                    <li>Random number generators</li>
                    <li>PKI infrastructure</li>
                    <li>Password cracking</li>
                    <li>TLS study via Wireshark traffic capture tool</li>
                </ul>
            `,
        },
      ],
    },
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    instructors: [course_instructors.KC],
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 36,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 29,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs 1,08,000</p></div>`,
  },
  {
    id: 8,
    parent_program_ids: [6],
    program_title: "Network Security",
    active: false,
    category: "Individual Course - Upcoming",
    program_start_date: "Jan 02, 2026",
    duration: "14 weeks",
    program_type: "Online",
    credits: "",
    level: "",
    image: `${network_security}`,
    description:
      "This course will equip participants to defend network environments against today’s complex and evolving threats. With a strong emphasis on applied learning, it dedicates substantial time to weekly lab-based exercises. Participants will gain a solid foundation in network fundamentals and examine attacks across various layers of the protocol stack, along with effective defense strategies. The course also covers securely designed modern network protocols and techniques for hardening organizational networks using popular open-source tools. From configuring secure protocols to identifying and mitigating vulnerabilities, participants will gain the skills needed to strengthen network defenses and confidently respond to security incidents.",
    course_details: {
      prerequisites: `<div><p class="size18 weight-700 mb-0">Pre-requisites:</p><ul><li>Knowledge of Unix command line</li><li>Knowledge of Computer Networks</li><li>Knowledge of cryptography highly recommended, though not essential</li></ul></div>`,
      duration: `<div><p class="size18 weight-700 mb-0">Fees: Different categories have different fees (inclusive of taxes) for this course:</p><ul><li>Student: Rs 36,000</li><li>Teacher: Rs 40,500</li><li>Others: Rs 45,000</li></ul></div>`,
    },
    course_content: {
      modules: [
        {
          module_name: "Network Background (Very quick Overview)",
          module_description: `
               
                <ul>
    <li><strong>Internet Protocol Stack:</strong></li>
    <li><strong>Link Layer technologies:</strong> Ethernet, Learning bridges, Wi-Fi, VLAN</li>
    <li><strong>Network Layer:</strong> IP Protocol, IP packet format, Addressing, fragmentation, Routing, DHCP, ICMP, NAT, IPv6</li>
    <li><strong>Transport Layer:</strong> TCP, UDP, QUIC</li>
    <li><strong>Application Layer:</strong> 
        <ul>
            <li>Domain Name System (DNS)</li>
            <li>Web Application (HTTP)</li>
            <li>Email Application (SMTP, IMAP, PIP)</li>
            <li>Multimedia Applications (RTP, RTSP, RTCP, SIP, HTTP-DASH, WebRTC)</li>
            <li>Simple Network Management Protocol (SNMP)</li>
        </ul>
    </li>
</ul>

                <p>Hand-in-hand with theory, practical sessions involving usage of 
                packet capture/manipulation tools like Wireshark, Scapy and popular network 
                commands like arp, ip, ping, ss, nc, dig, wget, curl, nmap etc will be covered.</p>
            `,
        },
        {
          module_name: "Network Attacks and Defenses",
          module_description: `
                <p>Attacks at various layers of the protocol stack will be covered:</p>
                <ul>
                    <li><strong>Link Layer:</strong> Eavesdropping via MAC flooding, ARP spoofing, VLAN Hopping, Wireless network Attacks.</li>
                    <li><strong>Network Layer:</strong> IPv4/IPv6, ICMP, DHCP, Routing based Attacks including DOS.</li>
                    <li><strong>Transport Layer:</strong> UDP and TCP based Attacks including DOS.</li>
                    <li><strong>Application Layer:</strong> DNS, Email, SNMP, Multimedia based Attacks, including DOS.</li>
                </ul>
                <p>Practical sessions will explore a subset of these attacks hands-on.</p>
            `,
        },
        {
          module_name: "Secure Network Protocols",
          module_description: `
                <p>This module covers secure network protocols at different layers:</p>
                <ul>
                    <li><strong>Link layer:</strong> 802.1X, WEP/WPA, MAC-sec.</li>
                    <li><strong>Network layer:</strong> IPsec, IKE, OpenVPN.</li>
                    <li><strong>Transport layer:</strong> TLS.</li>
                    <li><strong>Application Layer:</strong> SSH, DNSsec, DNS cookies, Email Security (S/MIME, DKIM, 
                    DMARC, STARTTLS, SMTP-AUTH, IMAP), SNMP security.</li>
                </ul>
                <p>Practical sessions will explore a subset of these protocols, essentially 
                configuration and exploration of the corresponding traffic via Wireshark.</p>
            `,
        },
        {
          module_name: "Network Hardening",
          module_description: `
                <p>This module covers:</p>
                <ul>
                    <li>Defense in depth, Vulnerability Scanners, Secure network topologies (DMZ, 
                    Network Segmentation), Secure Network Access Control, Firewalls, IDS, Honeypots and Honeynets.</li>
                </ul>
                <p>Practical sessions will explore network security tools like OpenVAS 
                (network vulnerability scanner), iptables (firewall configuration), 
                host and network intrusion detection (OSSEC and Snort).</p>
            `,
        },
      ],
    },
    instructors: [course_instructors.KC],
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 45,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 36,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs. 1,35,000</p></div>`,
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
  },
  {
    id: 5,
    parent_program_ids: [1, 6],
    program_title: "Web Security",
    active: false,
    category: "Individual Course - Upcoming",
    program_start_date: "May 04, 2026",
    duration: "14 weeks",
    program_type: "Online",
    credits: "",
    level: "",
    image: `${web_security}`,
    description:
      "This course will equip participants with the essential skills to secure web applications in an increasingly connected world. With twice as many lab hours compared to theory, this very hands-on course offers an in-depth exploration of how the web functions, the key principles of web security, common web application attacks, and effective defense strategies. Participants will gain practical, real-world insights into safeguarding web applications through actionable exercises. ",
    course_details: {
      duration: `<div><span class="size18">14 weeks, , PG Level, Online</span><p class="size18 weight-700 mb-0"> Structure:</p><ul class="size18"><li>1 - 1.5 hr videos per week</li><li>2.5 - 3 hr labs per week</li><li>Periodic 0.5 - 1 hr tutorials</li></ul><p class="size16">Expected time commitment: 6-8 hrs a week Interactions will be conducted during evenings/weekends</p></div>`,
      prerequisites: `<div><ul class="size18"><li>Knowledge of unix command line</li><li>Knowledge of Python, HTML, CSS, Javascript, SQL</li>
<li>Knowledge of Cryptography highly recommended, though not essential</li></ul></div>`,
    },
    instructors: [course_instructors.KC],
    course_content: {
      modules: [
        {
          module_name: "Module 1: Web Background",
          module_description: `
                <p>Motivation, brief history, what constitutes a web page, browser internals, web protocols, session management, server internals, web security landscape.</p>
                <p>Practical sessions will cover:</p>
                <ul>
                    <li>Usage of Wireshark to explore web protocol traffic</li>
                    <li>Firefox/Chrome browser developer tools to inspect/edit web pages</li>
                    <li>Cookies and storage</li>
                    <li>OWASP ZAP for web application security testing</li>
                </ul>
            `,
        },
        {
          module_name: "Module 2: Server Side Attacks and Defense",
          module_description: `
                <p>Topics covered include:</p>
                <ul>
                    <li>SQL (Structured Query Language) Injection</li>
                    <li>Server Side Request Forgery (SSRF)</li>
                    <li>Information Disclosure</li>
                    <li>Command Injection</li>
                    <li>File Upload Vulnerabilities</li>
                    <li>Authentication and Authorization</li>
                    <li>Path Traversal</li>
                    <li>Vulnerabilities in APIs</li>
                    <li>Server Side Template Injection</li>
                    <li>DOS Attacks</li>
                    <li>Web Application Firewalls</li>
                </ul>
                <p>Practical sessions will explore a subset of these server-side attacks and defenses hands-on.</p>
            `,
        },
        {
          module_name: "Module 3: Client Side Attacks and Defense",
          module_description: `
                <p>Topics covered include:</p>
                <ul>
                    <li>Cross Site Request Forgery (CSRF)</li>
                    <li>Cross Origin Resource Sharing (CORS)</li>
                    <li>Cross Site Scripting (XSS)</li>
                    <li>Web Sockets</li>
                    <li>Clickjacking</li>
                </ul>
                <p>Practical sessions will explore a subset of these client-side attacks and defenses hands-on.</p>
            `,
        },
        {
          module_name: "Module 4: Miscellaneous Topics",
          module_description: `
                <p>(A subset will be covered as per time availability):</p>
                <ul>
                    <li>Privacy</li>
                    <li>Third Party Code</li>
                    <li>Web LLM Attacks</li>
                    <li>HTTP Parameter Pollution</li>
                    <li>Subdomain Takeover</li>
                </ul>
            `,
        },
      ],
    },
    reviews: [
      {
        name: "Thèotime Flichy",
        college: "University of Montreal, Canada",
        video_src: `${web_security_student}`,
        poster: theotime_flichy_thumbnail,
        description: "CLab was fun and easy to use—small steps built up to complex tasks.",
      },
      {
        name: "Ignas Silickas",
        college: "KTH Royal Insitute of Technology, Sweden",
        video_src: `${friday_web_security}`,
        poster: ignas_silickas_thumbnail,
        description: "The hands-on labs and TA support made this one of the most enjoyable courses.",
      },
      {
        name: "Shruti Patil",
        college: "National Insitute of Technology, Goa",
        video_src: `${monday_web_security_student}`,
        poster: shruti_patil_thumbnail,
        description: "I loved how theory was followed by hands-on labs—my favorite part.",
      },
      {
        name: "Raj Pastagiya",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${raj_pastagiya}`,
        poster: raj_pastagiya_thumbnail,
        description: "Well-structured, with hands-on labs that made complex topics easy to understand.",
      },
      {
        name: "Kaustubh Saraf",
        college: "G.H. Raisoni COE, Nagpur",
        video_src: `${kaustubh_saraf_review}`,
        poster: kaustubh_saraf_thumbnail,
        description:
          "After solving the labs I was able to interpret the knowledge with real world scenarios.",
      },
      {
        name: "Satyankar Chandra",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${satyankar_chandra_review}`,
        poster: satyankar_chandra_thumbnail,
        description:
          "I found platform really convenient and simplistic to use. ",
      },
      {
        name: "Arnab Bhakta",
        college: "Indian Institute of Technology, Bombay",
        video_src: `${arnab_bhakta}`,
        poster: arnab_bhakta_thumbnail,
        description: "Now I write cleaner, more secure code—this course changed my whole approach.",
      },
    ],
    key_features: [
      "Certificate from IITB, the leading institute for Computer Science in India",
      "Conducted by award-winning teaching faculty",
      "Continuous hands-on learning via weekly labs as opposed to end-of-term course project",
      "Industry-based and vetted curriculum",
      "Continuous support and mentoring via Teaching Assistants",
      "High Quality Assessment: Proctored exams, not just theory but also lab exams",
    ],
    fees: `<div><p class="size18 mb-0"><strong>Industry Professionals & Govt. Officials:</strong> Rs 45,000 (Incl. GST)</p><p class="size18 mb-0"><strong>Academia & Students:</strong> Rs 36,000 (Incl. GST)</p><p class="size18 mb-0"><strong>International Participants:</strong> Rs. 1,35,000 </p></div>`,
    eligibility: `<div><ul class="size18"><li>Proficiency of the candidate in some programming language (C/C++/Python/Java/Bash etc) through college transcripts or any other certification.</li><li><strong>Regular Category:</strong> Anyone (working professionals, freelancers, etc.) with a recognized 3 or 4 year undergraduate degree in engineering or computer science related area</li><li><strong>Student Category:</strong><ul><li>Any student currently enrolled in a recognized 4-year UG academic program in any branch of Engineering (BE/BTech) or a 3 year UG academic program in Computer Science related areas (BSc/BCA etc.). Should have completed 2 years of course work.</li><li>Any student currently enrolled in a PG academic program in any branch of Engineering (MS/MTech) or in Computer Science related areas (MCA, MSc)</li></ul></li><li><strong>Teacher Category:</strong> Any teacher currently teaching in a recognized engineering or computer science related college</li></ul></div>`,
  },
];